module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "tabs is-boxed"
  }, [_c('ul', [_c('li', {
    class: _vm.activeTab === 'active' && 'is-active'
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.activeTab = 'active'
      }
    }
  }, [_c('span', [_vm._v("Tags (" + _vm._s(_vm.tags.length) + ")")])])]), _vm._v(" "), _c('li', {
    class: _vm.activeTab === 'archived' && 'is-active'
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.activeTab = 'archived'
      }
    }
  }, [_c('span', [_vm._v("Archived (" + _vm._s(_vm.archivedTags.length) + ")")])])])])]), _vm._v(" "), (_vm.activeTab == 'active') ? _c('div', [_vm._l((_vm.tags), function(tag) {
    return _c('section', {
      staticClass: "tags"
    }, [_c('Tag', {
      key: tag.id,
      attrs: {
        "id": tag.id,
        "rubric": tag.rubric,
        "color": tag.color,
        "title": tag.title,
        "owner": tag.owner,
        "groupTag": tag.group_tag
      }
    })], 1)
  }), _vm._v(" "), _c('section', {
    staticClass: "mt-4"
  }, [_c('span', {
    staticClass: "button is-large is-warning",
    on: {
      "click": function($event) {
        _vm.addTag(false)
      }
    }
  }, [_vm._v("Create Tag")]), _vm._v(" "), _c('span', {
    staticClass: "button is-large is-warning",
    on: {
      "click": function($event) {
        _vm.addTag(true)
      }
    }
  }, [_vm._v("Create Rubric Tag")])])], 2) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'archived') ? _c('div', _vm._l((_vm.archivedTags), function(tag) {
    return _c('section', {
      staticClass: "tags"
    }, [_c('Tag', {
      key: tag.id,
      attrs: {
        "id": tag.id,
        "rubric": tag.rubric,
        "color": tag.color,
        "title": tag.title,
        "owner": tag.owner,
        "groupTag": tag.group_tag
      }
    })], 1)
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-6cd6e6f5"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TagManager.vue
// module id = 1059
// module chunks = 0